/**
 * @file Client-side instrumentation that runs once when the browser JS boots,
 * before React hydrates.
 *
 * @see https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client
 */

import { startTokenRefreshEvents } from '@/utils/network-utils/token-refresh/events';

// Proactively refresh SLAS tokens when the user returns to the tab after
// being idle, so the first API call doesn't pay a refresh-latency penalty.
startTokenRefreshEvents();
